<app-navbar-two></app-navbar-two>
<div class="page-title-area item-bg-2" >
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content" style="margin-left: 13%;">
                    <h2>Projects Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Projects Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Our Portfolio - Alphurious Technologies</title>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    </head>
<section id="home" class="hero">
    <h1 class="hero-title"><span class="gradient-text1">Transforming Ideas Into </span>  <span class="gradient-text">Digital Reality</span></h1>
    <p class="hero-description">We deliver innovative solutions across Healthcare, Grocery, and Data sectors. Explore our portfolio to see how we help businesses thrive in the digital age.</p>
    <div class="hero-services">
        <div class="service-badge healthcare"><i class="fas fa-heartbeat"></i> Healthcare</div>
        <div class="service-badge grocery"><i class="fas fa-shopping-basket"></i> Grocery</div>
        <div class="service-badge data"><i class="fas fa-chart-line"></i> Data Solution</div>
        <div class="service-badge car"><i class="fas fa-car"></i> Automotive</div>
    </div>
</section>

<section id="portfolio" class="section portfolio-section">
    <div class="section-header">
        <h2 class="section-title" class="gradient-text1" >Our Service Portfolio</h2>
        <p class="section-description">Discover our comprehensive range of solutions</p>
    </div>

    <div class="filter-tabs">
        <button class="filter-btn" [ngClass]="{'active': currentFilter === 'all'}" (click)="filterProjects('all')">All Projects</button>
        <button class="filter-btn" [ngClass]="{'active': currentFilter === 'healthcare'}" (click)="filterProjects('healthcare')">Healthcare</button>
        <button class="filter-btn" [ngClass]="{'active': currentFilter === 'grocery'}" (click)="filterProjects('grocery')">Grocery</button>
        <button class="filter-btn" [ngClass]="{'active': currentFilter === 'data'}" (click)="filterProjects('data')">Data Solution</button>
        <button class="filter-btn" [ngClass]="{'active': currentFilter === 'automotive'}" (click)="filterProjects('automotive')">Automotive</button>
    </div>

    <div class="portfolio-grid">
        <div class="portfolio-card" 
             *ngFor="let projectId of projectKeys"
             [attr.data-category]="projects[projectId].category.toLowerCase().replace(' ', '')"
             [style.display]="currentFilter === 'all' || projects[projectId].category.toLowerCase().includes(currentFilter) ? 'block' : 'none'">

            <div *ngIf="projectId === 'healthcare1'" class="card-image healthcare-bg" (click)="openModal(projectId)">
                <i class="fas fa-hospital-user"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'healthcare1'" class="card-content">
                <div class="card-tags"><span class="tag">EHR</span><span class="tag">HIPAA</span><span class="tag">Cloud</span></div>
                <h4>Healthcare Software & Digital Health Solutions</h4>
                <p>Streamlined patient care with integrated scheduling, records, and billing.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status completed">Completed</span>
                </div>
            </div>

            <div *ngIf="projectId === 'healthcare2'" class="card-image healthcare-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-video"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'healthcare2'" class="card-content">
                <div class="card-tags"><span class="tag">Telehealth</span><span class="tag">Video</span><span class="tag">Secure</span></div>
                <h4>Telemedicine Platform</h4>
                <p>Connect patients with healthcare providers through secure video consultations.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fas fa-broadcast-tower"></i></span>
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'grocery1'" class="card-image grocery-bg" (click)="openModal(projectId)">
                <i class="fas fa-boxes-stacked"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'grocery1'" class="card-content">
                <div class="card-tags"><span class="tag">Azure</span><span class="tag">Inventory</span><span class="tag">Analytics</span></div>
                <h4>Smart Inventory System</h4>
                <p>Reduce waste and optimize stock levels with predictive analytics.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                        <span><i class="fas fa-cloud"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'grocery2'" class="card-image grocery-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-shopping-cart"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'grocery2'" class="card-content">
                <div class="card-tags"><span class="tag">E-Commerce</span><span class="tag">Mobile</span><span class="tag">React Native</span></div>
                <h4>E-Commerce Platform</h4>
                <p>Seamless online shopping with real-time delivery tracking.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-stripe"></i></span>
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status completed">Completed</span>
                </div>
            </div>

            <div *ngIf="projectId === 'data1'" class="card-image data-bg" (click)="openModal(projectId)">
                <i class="fas fa-chart-pie"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'data1'" class="card-content">
                <div class="card-tags"><span class="tag">BI</span><span class="tag">ETL</span><span class="tag">Analytics</span><span class="tag">Dashboard</span></div>
                <h4>Business Intelligence Dashboard</h4>
                <p>Transform raw data into actionable business insights.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fas fa-chart-bar"></i></span>
                        <span><i class="fa-solid fa-chart-column"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fab fa-python"></i></span>
                        <span><i>Azure</i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

            <div *ngIf="projectId === 'automotive1'" class="card-image data-bg-2" (click)="openModal(projectId)">
                <i class="fas fa-car"></i>
                <div class="card-overlay">
                    <button class="view-btn">View Details <i class="fas fa-arrow-right"></i></button>
                </div>
            </div>
            <div *ngIf="projectId === 'automotive1'" class="card-content">
                <div class="card-tags"><span class="tag">React Native</span><span class="tag">Mobile</span><span class="tag">CDN</span></div>
                <h4>Vehicle Marketplace Platform</h4>
                <p>Robust data infrastructure for seamless data flow.</p>
                <div class="card-footer">
                    <div class="tech-stack">
                        <span><i class="fab fa-react"></i></span>
                        <span><i class="fab fa-node-js"></i></span>
                        <span><i class="fas fa-database"></i></span>
                        <span><i class="fa-brands fa-microsoft"></i></span>
                        <span><i class="fas fa-code"></i></span>
                        <span><i class="fa-brands fa-angular"></i></span>
                    </div>
                    <span class="project-status in-progress">In Progress</span>
                </div>
            </div>

        </div>
    </div>
</section>

<section id="services" class="section services-section">
    <div class="section-header">
        <h2 class="section-title gradient-text1" >Service Categories</h2>
        <p class="section-description">Specialized solutions tailored to industry-specific needs</p>
    </div>

    <div class="services-grid">
        <div class="service-card healthcare-service">
            <div class="service-icon"><i class="fas fa-heartbeat"></i></div>
            <h3>Healthcare Solutions</h3>
            <p>Transforming patient care with cutting-edge digital health solutions.</p>
            <ul class="service-features">
                <li><i class="fas fa-check"></i> Electronic Health Records</li>
                <li><i class="fas fa-check"></i> Telemedicine Platforms</li>
                <li><i class="fas fa-check"></i> Medical IoT Integration</li>
                <li><i class="fas fa-check"></i> Healthcare Analytics</li>
            </ul>
            <div class="service-stats">
                <div><span class="stat-number">5+</span><span class="stat-label">Projects</span></div>
                <div><span class="stat-number">98%</span><span class="stat-label">Satisfaction</span></div>
            </div>
        </div>

        <div class="service-card grocery-service">
            <div class="service-icon"><i class="fas fa-shopping-basket"></i></div>
            <h3>Grocery Solutions</h3>
            <p>Revolutionizing retail with smart inventory and e-commerce platforms.</p>
            <ul class="service-features">
                <li><i class="fas fa-check"></i> Inventory Management</li>
                <li><i class="fas fa-check"></i> E-Commerce Platforms</li>
                <li><i class="fas fa-check"></i> Supply Chain Analytics</li>
                <li><i class="fas fa-check"></i> POS Integration</li>
            </ul>
            <div class="service-stats">
                <div><span class="stat-number">2+</span><span class="stat-label">Projects</span></div>
                <div><span class="stat-number">95%</span><span class="stat-label">Satisfaction</span></div>
            </div>
        </div>

        <div class="service-card data-service">
            <div class="service-icon"><i class="fas fa-chart-line"></i></div>
            <h3>Data Solutions</h3>
            <p>Unlock the power of your data with comprehensive analytics and BI solutions.</p>
            <ul class="service-features">
                <li><i class="fas fa-check"></i> Business Intelligence</li>
                <li><i class="fas fa-check"></i> Data Warehousing</li>
                <li><i class="fas fa-check"></i> Data Engineering </li>
                <li><i class="fas fa-check"></i> Predictive Analytics</li>
                
            </ul>
            <div class="service-stats">
                <div><span class="stat-number">3+</span><span class="stat-label">Projects</span></div>
                <div><span class="stat-number">99%</span><span class="stat-label">Satisfaction</span></div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="section contact-section">
    <div class="contact-container">
        <div class="contact-info">
            <h2>Let's Work Together</h2>
            <p>Have a project in mind? We'd love to hear about it.</p>
            <div class="contact-details">
                <div class="contact-item">
                    <i class="fas fa-phone"></i>
                    <div><h4>Phone</h4><a href="tel:+91-6283068477">+91-6283068477</a></div>
                </div>
                <div class="contact-item">
                    <i class="fas fa-envelope"></i>
                    <div><h4>Email</h4><a href="mailto:contactus@alphurious.com">contactus@alphurious.com</a></div>
                </div>
                <div class="contact-item">
                    <i class="fas fa-map-marker-alt"></i>
                    <div><h4>Address</h4><p>S.A.S. Nagar (Mohali), Punjab - 140603, India</p></div>
                </div>
            </div>
        </div>
<form #contactForm="ngForm" (ngSubmit)="submitContact(contactForm)">



  <div class="form-group">
    <input
      type="text"
      name="name"
      ngModel
      placeholder="Your Name"
      required
    />
  </div>

  <div class="form-group">
    <input
      type="email"
      name="email"
      ngModel
      placeholder="Email Address"
      required
    />
  </div>

  <div class="form-group">
    <select name="subject" ngModel required>
      <option value="" disabled selected>Select Service</option>
      <option value="Healthcare Solutions">Healthcare Solutions</option>
      <option value="Grocery Solutions">Grocery Solutions</option>
      <option value="Data Solutions">Data Solutions</option>
      <option value="Other">Other</option>
    </select>
  </div>

  <div class="form-group">
    <textarea
      rows="4"
      name="message"
      ngModel
      placeholder="Your Message"
      required
    ></textarea>
  </div>

  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="contactForm.invalid"
  >
    Send Message <i class="fas fa-paper-plane"></i>
  </button>
                        <div *ngIf="successMessage" class="success_div">
                            {{successMessage}}
                        </div>

                        <div *ngIf="errorMessage" class="error_div">
                            {{errorMessage}}
                        </div>
</form>


    </div>
</section>

<div id="projectModal" class="modal" [ngClass]="{'active': isModalOpen}" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <button class="modal-close" (click)="closeModal()">&times;</button>
        <div id="modalBody" *ngIf="selectedProject">
            <div class="modal-header">
                <span class="category-badge">{{ selectedProject.category }}</span>
                <h2>{{ selectedProject.title }}</h2>
                <p>{{ selectedProject.subtitle }}</p>
            </div>
            <div class="modal-body">
                <div class="modal-section">
                    <h3><i class="fas fa-info-circle"></i> Overview</h3>
                    <p>{{ selectedProject.overview }}</p>
                </div>
                <div class="modal-section">
                    <h3><i class="fas fa-list-check"></i> Key Features</h3>
                    <ul>
                        <li *ngFor="let feature of selectedProject.features"><i class="fas fa-check-circle"></i> {{ feature }}</li>
                    </ul>
                </div>
                <div class="modal-section">
                    <h3><i class="fas fa-code"></i> Technologies Used</h3>
                    <div class="modal-tech">
                        <span *ngFor="let tech of selectedProject.technologies">{{ tech }}</span>
                    </div>
                </div>
                <!-- <div class="modal-section">
                    <h3><i class="fas fa-trophy"></i> Results</h3>
                    <div class="modal-results"><p>{{ selectedProject.results }}</p></div>
                </div> -->
                <div class="modal-section">
    <h3><i class="fas fa-trophy"></i> Results</h3>
<div class="modal-results">
    <!-- If results is a single string -->
    <p *ngIf="!isResultsArray(selectedProject?.results)">
        {{ selectedProject?.results }}
    </p>

    <!-- If results is an array -->
    <ul *ngIf="isResultsArray(selectedProject?.results)">
        <li *ngFor="let result of selectedProject?.results">
            <i class="fas fa-check-circle"></i> {{ result }}
        </li>
    </ul>
    </div>
</div>

                <div class="modal-section">
                    <h3><i class="fas fa-images"></i> Project Gallery</h3>
                    <div class="modal-gallery">
                        <img *ngFor="let img of selectedProject.images" [src]="img" alt="Project screenshot">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</html>